import React, { useState } from 'react';
import { Popper } from '@mui/material';
import {
  SubMenu,
} from 'react-pro-sidebar';
import AnchorWrapper from './AnchorWrapper';
import PopperContent from './PopperContent';

const CustomSubMenu = ({ props }: { props: any }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openPopper, setOpenPopper] = useState(false);
  const id = props?.id;

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper(true);
  };

  const handleMouseLeave = () => {
    setOpenPopper(false);
  };

  const open = Boolean(anchorEl) && openPopper;
  const popperId = open ? `popper-${id}` : undefined;

  return (
    <>
      <AnchorWrapper
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseEnter}
        popperId={popperId}
      >
        <SubMenu label={props.label} icon={props.icon}>
          {!props.collapsed &&
            props.items.map((item: any) => {
              return item;
            })}
        </SubMenu>
      </AnchorWrapper>

      <Popper
        id={popperId}
        open={open && props.collapsed}
        anchorEl={anchorEl}
        placement="right-end"
        style={{ zIndex: 100 }}
      >
        <PopperContent
          onClickAway={handleMouseLeave}
          onMouseEnter={() => setOpenPopper(true)}
          onMouseLeave={handleMouseLeave}
          items={props.popperItems}
        />
      </Popper>
    </>
  );
};

export default CustomSubMenu;
